import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

class AsteriskIcon extends React.Component {

    render() {
        return (
            <SvgIcon {...this.props}>
                <g id="Group_199" data-name="Group 199" transform="translate(-1079 -226)">
                    <path id="Path_1448" data-name="Path 1448" d="M247.757,283.019,243.987,281l3.77-2.018a1.293,1.293,0,0,0,.53-1.836l-.8-1.291a1.513,1.513,0,0,0-1.98-.492l-3.769,2.019v-4.037a1.4,1.4,0,0,0-1.45-1.344h-1.607a1.4,1.4,0,0,0-1.45,1.344v4.037l-3.769-2.019a1.513,1.513,0,0,0-1.98.492l-.8,1.291a1.292,1.292,0,0,0,.53,1.836l3.77,2.018-3.77,2.019a1.291,1.291,0,0,0-.53,1.836l.8,1.291a1.513,1.513,0,0,0,1.98.492l3.769-2.019v4.037a1.4,1.4,0,0,0,1.45,1.344h1.607a1.4,1.4,0,0,0,1.45-1.344v-4.037l3.769,2.019a1.513,1.513,0,0,0,1.98-.492l.8-1.291A1.292,1.292,0,0,0,247.757,283.019Z" transform="translate(851.518 -43)" fill="#616161" />
                    <path id="Path_1432" data-name="Path 1432" d="M0,0H24V24H0Z" transform="translate(1079 226)" fill="none" />
                    <path id="Path_1434" data-name="Path 1434" d="M0,0H24V24H0Z" transform="translate(1079 226)" fill="none" />
                </g>
            </SvgIcon>
        );
    }
}

export default AsteriskIcon;